import * as ReactService from "@intech/react-service";
import { PlanoVinculadoEntidade } from "../entidades/PlanoVinculadoEntidade";

class Plano extends ReactService.BaseService {
  constructor() {
    super("Plano");
  }

  Buscar = () =>
    this.CreateRequest<PlanoVinculadoEntidade[]>(ReactService.RequestType.GET, `Buscar`);

  BuscarPorCodigo = (cdPlano: string) =>
    this.CreateRequest<PlanoVinculadoEntidade>(ReactService.RequestType.GET, `BuscarPorCodigo/${cdPlano}`);

  BuscarTempoPlano = (cdPlano: string) =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `BuscarTempoPlano/${cdPlano}`);

}

export const PlanoService = new Plano();
